<div class="reptile-similar-products__header">
    <h2 class="reptile-similar-products__headline">Ähnliche Artikel</h2>
</div>

<style lang="scss">
    @use '@otto-ec/design-tokens/tokens';

    .reptile-similar-products {
        &__header {
            display: block;
            grid-column: 1/-1;
        }

        &__headline {
            width: 100%;
            margin: tokens.$oc-semantic-spacing-absolute-0;
            padding: tokens.$oc-semantic-spacing-absolute-250 tokens.$oc-semantic-spacing-absolute-100
                tokens.$oc-semantic-spacing-absolute-150;

            font: tokens.$oc-semantic-font-headline-300;

            background: tokens.$oc-semantic-color-background-canvas;
        }
    }
</style>
